module.exports = web3dPluginPotreeManager;